/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useDeviceMediaQuery } from '../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { Segment, Statistic, StatisticLabel, StatisticValue } from 'semantic-ui-react'
import { ValueVariation } from '../Dashboard/Shared/ValueVariation'

const Summary = () => {
    const {isMobile} = useDeviceMediaQuery()

    return (
      <Segment
        css={css`
                display: grid;
                grid-template-areas: ${isMobile ?`'a' 'd'` :
          `"a b"
                        "c d"`};
                grid-template-columns: ${isMobile ? '1fr' : '1fr 1fr'};
                row-gap: .5rem;
            `}
      >
          <Statistic
            css={css`
                    grid-area: a;
                `}
            size="small"
          >
              <StatisticValue>
                  5km
                  <ValueVariation
                    value={5}
                    referenceValue={4.5}
                    formatter={(value) => `${value}km`}
                  />
              </StatisticValue>
              <StatisticLabel>Distance maximum de livraison</StatisticLabel>
          </Statistic>

          <Statistic
            css={css`
                    grid-area: b;
                `}
            size="small"
          >
              <Statistic.Value>
                  1.43km
                  <ValueVariation
                    value={1.4}
                    referenceValue={2.1}
                    formatter={(value) => `${value.toFixed(2)}km`}
                  />
              </Statistic.Value>
              <Statistic.Label>Distance moyenne de livraison</Statistic.Label>
          </Statistic>
      </Segment>
    )
}

export { Summary }
